import { render, staticRenderFns } from "./dialog-view-columns.vue?vue&type=template&id=a3ae0736&scoped=true"
import script from "./dialog-view-columns.vue?vue&type=script&lang=js"
export * from "./dialog-view-columns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ae0736",
  null
  
)

export default component.exports